import {Esim} from '@chekin/core';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@chekin/guestapp-ui-kit';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import {ChevronUpIcon, ChevronDownIcon} from 'lucide-react';
import {useEsimInstructions} from 'hooks/esim/useEsimInstructions';
import {InstractionCard} from './InstractionCard/InstractionCard';
import cn from 'clsx';

type Props = {
  className?: string;
  esim: Esim;
};
export const PurchasedPlan = ({className, esim}: Props) => {
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);
  const {data} = useEsimInstructions({id: esim.id});

  return (
    <li
      className={cn(
        'flex flex-col gap-1 p-4 rounded-2xl border border-gray-200 bg-[var(--card)]',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col leading-6">
          <div className="font-semibold">{esim.package_title}</div>
          <div className="text-sm">
            {esim.package_days} {t('esim.my.days')}
          </div>
        </div>
        <img
          src={esim.operator_image_url}
          alt={esim.operator_title}
          className="h-14 object-cover aspect-[11/7] rounded-md"
        />
      </div>

      <Collapsible
        open={open}
        onOpenChange={setOpen}
        className="flex flex-col gap-6 items-start"
      >
        <CollapsibleTrigger className="flex items-center justify-start gap-2 text-[var(--primary)] [--lucide-stroke-width:3]">
          {open ? (
            <>
              <span className="text-sm font-semibold">
                {t('esim.my.hide_installation_guide')}
              </span>
              <ChevronUpIcon size={16} />
            </>
          ) : (
            <>
              <span className="text-sm font-semibold">
                {t('esim.my.read_installation_guide')}
              </span>
              <ChevronDownIcon size={16} />
            </>
          )}
        </CollapsibleTrigger>
        <CollapsibleContent className="w-full">
          {data?.instructions && <InstractionCard instructions={data.instructions} />}
        </CollapsibleContent>
      </Collapsible>
    </li>
  );
};
